import { Tooltip } from 'antd';
import React from 'react';
import {
  FiArchive,
  FiX,
  FiEdit,
  FiEye,
  FiFile,
  FiFileText,
  FiToggleLeft,
  FiToggleRight,
  FiUser
} from 'react-icons/fi';
import {
  IoAddOutline,
  IoCloudDownload,
  IoRemoveOutline
} from 'react-icons/io5';
import { IoMdTrash } from 'react-icons/io';
import { downloadRaportPerMeasure } from '../network/measure';
import { measuresTypes } from '../types/measures';
import { messageMapping } from '../types/menu-statuses';
import { users_status } from '../types/users';
import { dateIsOld } from './date';
import {
  IAccount,
  IDecisionReport,
  ILitigation,
  IMeasure,
  IMonitorization
} from './interfaces/interfaces';
import { fullName, prettyDate } from './strings';
import { Priorities } from '../types/litigations';
import { getRole } from '../localStorage';
import { Types, types_users } from '../types/users';

const columns_secondary_accounts = (styles: any, openEdit: any) => [
  {
    title: 'Nume',
    dataIndex: 'lastName',
    sorter: {
      compare: (a: any, b: any) => (a.lastName - b.lastName ? -1 : 1)
    }
  },
  {
    title: 'Prenume',
    dataIndex: 'firstName',
    sorter: {
      compare: (a: any, b: any) => (a.firstName - b.firstName ? -1 : 1)
    }
  },
  {
    title: 'Adresa de mail',
    dataIndex: 'email'
  },
  {
    title: 'Tip',
    dataIndex: 'type',
    render: (el: any, entry: IAccount) =>
      entry.type === 'legal'
        ? 'Litigii'
        : entry.type === 'accounting'
        ? 'Rapoarte de control'
        : 'Litigii si Rapoarte de control'
  },
  {
    title: 'Număr de telefon',
    dataIndex: 'phone'
  },
  {
    title: '',
    dataIndex: 'edit',
    render: (el: any, entry: IAccount) => (
      <div className={styles.edit}>
        <FiEdit onClick={() => openEdit(entry)} />
      </div>
    )
  }
];

const columns_secondary_admin = (styles: any, openEditSecondary: any) => [
  {
    title: 'Nume',
    dataIndex: 'lastName',
    sorter: {
      compare: (a: any, b: any) => (a.lastName - b.lastName ? -1 : 1)
    }
  },
  {
    title: 'Prenume',
    dataIndex: 'firstName',
    sorter: {
      compare: (a: any, b: any) => (a.firstName - b.firstName ? -1 : 1)
    }
  },
  {
    title: 'Adresa de mail',
    dataIndex: 'email'
  },
  {
    title: 'Număr telefon',
    dataIndex: 'phone'
  },
  {
    title: 'Instituție',
    dataIndex: 'institutionName',
    sorter: {
      compare: (a: any, b: any) =>
        a.institutionName - b.institutionName ? -1 : 1
    }
  },
  {
    title: 'Cont principal',
    dataIndex: 'principalUser',
    render: (el: any) => fullName(el)
  },
  {
    title: '',
    dataIndex: 'edit',
    render: (el: any, entry: IAccount) => (
      <div className={styles.edit}>
        <FiEdit onClick={() => openEditSecondary(entry)} />
      </div>
    )
  }
];

const columns_principal_accounts = (
  openEdit: any,
  enable: any,
  disable: any,
  decreaseNumber: any,
  increaseNumber: any,
  styles: any
) => [
  {
    title: 'Nume',
    dataIndex: 'lastName',
    sorter: {
      compare: (a: any, b: any) => (a.lastName - b.lastName ? -1 : 1)
    }
  },
  {
    title: 'Prenume',
    dataIndex: 'firstName',
    sorter: {
      compare: (a: any, b: any) => (a.firstName - b.firstName ? -1 : 1)
    }
  },
  {
    title: 'Adresa de mail',
    dataIndex: 'email'
  },
  {
    title: 'Număr telefon',
    dataIndex: 'phone'
    // sorter: {
    //   compare: (a: any, b: any) => (a.data - b.date ? -1 : 1)
    // }
  },
  {
    title: 'Instituție',
    dataIndex: 'institutionName',
    sorter: {
      compare: (a: any, b: any) =>
        a.institutionName - b.institutionName ? -1 : 1
    }
  },
  {
    title: 'Expirare contract',
    dataIndex: 'contractExpirationDate',
    sorter: {
      compare: (a: any, b: any) =>
        a.contractExpirationDate - b.contractExpirationDate ? -1 : 1
    },
    render: (el: string) => (
      <p className={dateIsOld(el) ? 'error' : ''}>
        {el ? prettyDate(el) : 'Nu a fost completat'}
      </p>
    )
  },

  {
    title: 'Status',
    dataIndex: 'status'
  },
  {
    title: 'Număr de utilizatori',
    dataIndex: 'secondaryAccountAllowance',
    render: (el: any, entry: IAccount) => (
      <div className={styles.accountsManage}>
        <button>
          <IoRemoveOutline onClick={() => decreaseNumber(entry)} />
        </button>
        <p>{el}</p>
        <button>
          <IoAddOutline onClick={() => increaseNumber(entry)} />
        </button>
      </div>
    )
  },
  {
    title: '',
    dataIndex: 'actions',
    render: (el: any, entry: IAccount) => (
      <div className={styles.actions}>
        {entry.status === users_status.disabled ? (
          <FiToggleLeft
            className={styles.disabled}
            onClick={() => enable(entry)}
          />
        ) : (
          <FiToggleRight onClick={() => disable(entry)} />
        )}
      </div>
    )
  },
  {
    title: '',
    dataIndex: 'edit',
    render: (el: any, entry: IAccount) => (
      <div className={styles.edit}>
        <FiEdit onClick={() => openEdit(entry)} />
      </div>
    )
  }
];

const columnsMeasures = (
  monitorization: IMonitorization,
  styles: any,
  openObservations: any,
  handleDocuments: any,
  getDocuments: any,
  getLitigii: any,
  setMeasure?: any,
  setEditModal?: any,
  user?: any
) => {
  const col = [
    {
      title: 'Număr',
      dataIndex: 'number'
    },
    {
      title:
        monitorization.type === measuresTypes.MEASURES
          ? !user?.institution.private
            ? 'Măsura'
            : 'Măsura / Contract'
          : !user?.institution.private
          ? 'Recomandarea'
          : 'Recomandarea / Contract',
      dataIndex: 'description'
    },
    {
      title: 'Termen de implementare',
      dataIndex: 'originalDeadline',
      render: (value: Date) => prettyDate(value),
      sorter: {
        compare: (a: any, b: any) =>
          a.originalDeadline - b.originalDeadline ? -1 : 1
      }
    },
    {
      title: 'Termen prelungit',
      dataIndex: 'prolongedDeadline',
      render: (value: Date) =>
        value ? prettyDate(value) : 'Nu a fost modificat'
    },
    {
      title: 'Status',
      dataIndex: 'status',
      render: (el: any) => messageMapping(el) || 'In curs de implementare',
      sorter: {
        compare: (a: any, b: any) => (a.status - b.status ? -1 : 1)
      }
    },
    {
      title: 'Responsabili',
      dataIndex: 'responsiblePerson',
      sorter: {
        compare: (a: any, b: any) =>
          a.responsiblePerson - b.responsiblePerson ? -1 : 1
      }
    },
    {
      title: 'Observații',
      dataIndex: 'actions',
      render: (_: any, entry: IMeasure) => (
        <div className={styles.actions}>
          <span
            className={styles.actionButton}
            onClick={() => {
              setMeasure(entry);
              openObservations(true);
            }}
          >
            Vizualizați
          </span>
        </div>
      )
    },
    {
      title: 'Documente',
      dataIndex: 'documents',
      render: (_: any, entry: IMeasure) => (
        <div className={styles.actions}>
          <span
            className={styles.actionButton}
            onClick={async () => {
              await handleDocuments(entry);
            }}
          >
            Documente
          </span>
        </div>
      )
    },
    {
      title: 'Litigii',
      dataIndex: 'litigii',
      render: (_: any, entry: IMeasure) => (
        <div className={styles.actions}>
          <span
            className={styles.actionButton}
            onClick={async () => {
              await getLitigii(entry);
            }}
          >
            Litigii
          </span>
        </div>
      )
    },
    {
      title: '',
      dataIndex: 'download',
      render: (_: any, entry: IMeasure) => (
        <div className={styles.actions}>
          {
            <Tooltip title='Descarcati raportul privind deadline-ul.'>
              <IoCloudDownload
                onClick={() =>
                  downloadRaportPerMeasure(
                    entry.id,
                    entry.number,
                    `Monitorizare ${monitorization.name} cu numarul ${monitorization.number}`
                  )
                }
              />
            </Tooltip>
          }
        </div>
      )
    }
  ];
  if (setMeasure && setEditModal) {
    col.push({
      title: '',
      dataIndex: 'edit',
      render: (_: any, entry: IMeasure) => (
        <div className={styles.actions}>
          {
            <FiEdit
              onClick={async () => {
                await getDocuments(entry);
                setMeasure(entry);
                setEditModal(true);
              }}
            />
          }
        </div>
      )
    });
  }
  return col;
};

const columnsLitigations = (
  styles: any,
  openPriority: any,
  handleEditField: any,
  handleDocuments: any,
  handleArchive: any,
  handleViewDetails: any,
  setLitigation?: any,
  setEditModal?: any,
  setEditArchiveModal?: any,
  setPermissionsModal?: any,
  deleteLitigation?: any
) => {
  const col = [
    {
      title: 'ID',
      dataIndex: 'id',
      sorter: true,
      render: (el: any, entry: ILitigation) => (
        <div className={styles.actions}>
          <span
            className={styles.actionButton}
            onClick={async () => {
              handleViewDetails(entry);
            }}
          >
            {el}
          </span>
        </div>
      )
    },
    {
      title: 'Nr. dosar instanta',
      dataIndex: 'uniqueFileNumber',
      render: (el: any, entry: ILitigation) => (
        <div className={styles.actions}>
          <span
            className={styles.actionButton}
            onClick={async () => {
              handleViewDetails(entry);
            }}
          >
            {el}
          </span>
        </div>
      )
    },
    {
      title: 'Instanta',
      dataIndex: 'court',
      render: (el: any, entry: ILitigation) => (
        <div
          className={styles.truncate}
          onClick={() => {
            setLitigation(entry);
            handleEditField({
              key: 'court',
              originalValue: entry.court,
              label: 'Instanta'
            });
          }}
        >
          {el}
        </div>
      )
    },

    {
      title: 'Partile si calitatea procesuala',
      dataIndex: 'parties',
      render: (el: any, entry: ILitigation) => (
        <div
          className={styles.truncate}
          onClick={() => {
            setLitigation(entry);
            handleEditField({
              key: 'parties',
              originalValue: entry.parties,
              label: 'Partile si calitatea procesuala'
            });
          }}
        >
          {el}
        </div>
      )
    },
    {
      title: 'Obiect',
      dataIndex: 'object',
      render: (el: any, entry: ILitigation) => (
        <div
          className={styles.truncate}
          onClick={() => {
            setLitigation(entry);
            handleEditField({
              key: 'object',
              originalValue: entry.object,
              label: 'Obiect'
            });
          }}
        >
          {el}
        </div>
      )
    },
    {
      title: 'Grad importanta dosar',
      dataIndex: 'priority',
      render: (el: any, entry: ILitigation) => {
        let priority = 'NORMALA';
        switch (el) {
          case Priorities.High:
            priority = 'RIDICATA';
            break;
          case Priorities.Medium:
            priority = 'MEDIE';
            break;
          case Priorities.Normal:
            priority = 'NORMALA';
            break;
        }
        return (
          <div className={styles.actions}>
            <span
              className={
                el === Priorities.High
                  ? styles.highPriority
                  : styles.actionButton
              }
              onClick={() => {
                setLitigation(entry);
                openPriority(true);
              }}
            >
              {priority}
            </span>
          </div>
        );
      }
    },
    {
      title: 'Stadiu procesual',
      dataIndex: 'stage',
      render: (el: any, entry: ILitigation) => (
        <div
          onClick={() => {
            // setLitigation(entry);
            // handleEditField({
            //   key: 'stage',
            //   originalValue: entry.stage,
            //   label: 'Stadiu procesual'
            // });
          }}
        >
          {el}
        </div>
      )
    },
    {
      title: 'Acte de procedura comunicate',
      dataIndex: 'documents',
      render: (_: any, entry: ILitigation) => (
        <div className={styles.actions}>
          <span
            className={entry.documents.length === 0 ? '' : styles.actionButton}
            onClick={async () => {
              await handleDocuments(entry);
            }}
          >
            Documente
          </span>
        </div>
      )
    },
    {
      title: 'Arhivă electronică',
      dataIndex: 'archive',
      render: (_: any, entry: IMeasure) => (
        <div className={styles.actions}>
          <span
            className={styles.actionButton}
            onClick={async () => {
              await handleArchive(entry);
            }}
          >
            Arhivă
          </span>
        </div>
      )
    },
    {
      title: 'Termen instanta de judecata',
      dataIndex: 'term',
      render: (el: Date, entry: ILitigation) => (
        <div
          onClick={() => {
            // setLitigation(entry);
            // handleEditField({
            //   key: 'term',
            //   originalValue: entry.term,
            //   label: 'Termen instanta de judecata	'
            // });
          }}
        >
          {prettyDate(el)}
        </div>
      ),
      sorter: true,
      width: 160
    },
    {
      title: 'Solutie pe scurt',
      dataIndex: 'solution',
      render: (el: any, entry: ILitigation) => (
        <div
          className={styles.truncate}
          onClick={() => {
            setLitigation(entry);
            handleEditField({
              key: 'solution',
              originalValue: entry.solution,
              label: 'Solutie pe scurt'
            });
          }}
        >
          {el}
        </div>
      )
    },
    {
      title: 'Observații',
      dataIndex: 'actions',
      render: (_: any, entry: ILitigation) => (
        <div className={styles.actions}>
          <span
            className={styles.actionButton}
            onClick={() => {
              setLitigation(entry);
              handleEditField({
                key: 'observations',
                originalValue: entry.observations,
                label: 'Observatii'
              });
            }}
          >
            Vizualizați
          </span>
        </div>
      )
    },
    {
      title: '',
      dataIndex: 'details',
      render: (_: any, entry: ILitigation) => (
        <div className={styles.actions}>
          {entry.xml && (
            <FiFileText
              onClick={async () => {
                handleViewDetails(entry);
              }}
            />
          )}
        </div>
      )
    },
    {
      title: '',
      dataIndex: 'edit',
      render: (_: any, entry: ILitigation) => (
        <div className={styles.actions}>
          {
            <FiArchive
              onClick={async () => {
                setLitigation(entry);
                setEditArchiveModal(true);
              }}
            />
          }
        </div>
      )
    },
    {
      title: '',
      dataIndex: 'edit',
      render: (_: any, entry: ILitigation) => (
        <div className={styles.actions}>
          {
            <FiEdit
              onClick={async () => {
                setLitigation(entry);
                setEditModal(true);
              }}
            />
          }
        </div>
      )
    },
    {
      title: '',
      dataIndex: 'permissions',
      render: (_: any, entry: ILitigation) => {
        const role = getRole();
        return (
          role &&
          role === types_users.principal && (
            <div className={styles.actions}>
              {
                <FiUser
                  onClick={async () => {
                    setLitigation(entry);
                    setPermissionsModal(true);
                  }}
                />
              }
            </div>
          )
        );
      }
    },
    {
      title: '',
      dataIndex: 'delete',
      render: (_: any, entry: ILitigation) => {
        return (
          <div className={styles.actions}>
            {
              <FiX
                onClick={async () => {
                  if (window.confirm('Confirmati stergerea acestui dosar')) {
                    setPermissionsModal(true);
                    deleteLitigation(entry.id);
                  }
                }}
              />
            }
          </div>
        );
      }
    }
  ];
  return col;
};

const columnsAcquisitions = (handleDeleteRow: any) => [
  {
    title: 'Nr. Crt.',
    dataIndex: 'nrCrt',
    sorter: {
      compare: (a: any, b: any) => (a.crt - b.crt ? -1 : 1)
    },
    editable: true
  },
  {
    title: 'Articol bugetar',
    dataIndex: 'articolBugetar',
    editable: true
  },
  {
    title: 'Denumire achizitie',
    dataIndex: 'denumireAchizitie',
    editable: true
  },
  {
    title: 'Cod CPV',
    dataIndex: 'codCPV',
    sorter: {
      compare: (a: any, b: any) => (a.cpv - b.cpv ? -1 : 1)
    },
    editable: true
  },
  {
    title: 'Valoare estimată (Lei fără TVA)',
    dataIndex: 'valoareEstimata',
    editable: true
  },
  {
    title: 'Credite bugetare aprobate (Lei)',
    dataIndex: 'crediteBugetareAprobate',
    editable: true
  },
  {
    title: 'Nr. angajament bugetar',
    dataIndex: 'angajamentBugetar',
    editable: true
  },
  {
    title: 'Dată angajament bugetar',
    dataIndex: 'dataAngajamentBugetar',
    editable: true
  },
  {
    title: 'Valoare angajament bugetar (Lei cu TVA)',
    dataIndex: 'valoareAngajamentBugetar',
    editable: true
  },
  {
    title: 'Procedura de achiziție',
    dataIndex: 'proceduraDeAchizitie',
    editable: true
  },
  {
    title: 'Ofertanți (Denumire firmă)',
    dataIndex: 'ofertanti',
    editable: true
  },
  {
    title: 'Criteriu de evaluare a ofertelor',
    dataIndex: 'criteriuEvaluareOferta',
    editable: true
  },
  {
    title: 'Valoare ofertă (Lei fără TVA)',
    dataIndex: 'valoareOferta',
    editable: true
  },
  {
    title: 'Punctaj obținut',
    dataIndex: 'punctajObtiut',
    editable: true
  },
  {
    title: 'Valoare desemnată câștigătoare (Lei cu TVA)',
    dataIndex: 'valoareCastigatoare',
    editable: true
  },
  {
    title: 'Nr. angajament legal',
    dataIndex: 'angajamentLegal',
    editable: true
  },
  {
    title: 'Dată angajament legal',
    dataIndex: 'dataAngajamentLegal',
    editable: true
  },
  {
    title: 'Valoare angajament legal (Lei cu TVA)',
    dataIndex: 'valoareAngajamentLegal',
    editable: true
  },
  {
    title: 'Nr. factură',
    dataIndex: 'facturaNr',
    editable: true
  },
  {
    title: 'Dată factură',
    dataIndex: 'facturaData',
    editable: true
  },
  {
    title: 'Nr. ordonanțare la plată',
    dataIndex: 'ordonantarePlataNr',
    editable: true
  },
  {
    title: 'Dată ordonanțare la plată',
    dataIndex: 'ordonantarePlataData',
    editable: true
  },
  {
    title: 'Plăți efectuate (Lei)',
    dataIndex: 'platiEfectuateValoare',
    editable: true
  },
  {
    title: 'Angajamente legale rămase de plată (Lei)',
    dataIndex: 'angajamenteLegaleRamasePlata',
    editable: true
  },
  {
    title: 'Nr. notei de intrare recepție/procesului verbal de recepție',
    dataIndex: 'nrDataNotaIntrareReceptie',
    editable: true
  },
  {
    title: 'Data notei de intrare recepție/procesului verbal de recepție',
    dataIndex: 'dataDataNotaIntrareReceptie',
    editable: true
  },
  {
    title: 'Observații',
    dataIndex: 'observatii',
    editable: true
  },
  {
    title: 'Șterge rând',
    dataIndex: 'deleteRow',
    render: (_: any, entry: any) => (
      <IoMdTrash
        onClick={() => handleDeleteRow(entry)}
        style={{ opacity: 1, fontSize: '1.5rem', color: '#ff6052' }}
      />
    )
  }
];

const generateTable = (year: string) => [
  {
    year,
    entries: []
  }
];

export {
  columns_secondary_accounts,
  columns_secondary_admin,
  columns_principal_accounts,
  columnsMeasures,
  columnsLitigations,
  columnsAcquisitions,
  generateTable
};
